import zreportapi from "../../../../services/zreport";

export const fetchDebtInformationsApi = async (branchId, transactionDate) => {
  const response = await zreportapi.get(
    `DataDebtInformations/branch/${branchId}/transaction-date/${transactionDate}?page=1&size=100`
  );
  return response.data;
};

export const addDebtInformationApi = async (debtInfo) => {
  const response = await zreportapi.post("DataDebtInformations", debtInfo);
  return response.data;
};

export const updateDebtInformationApi = async (id, debtInfo) => {
  const response = await zreportapi.put(`DataDebtInformations/${id}`, debtInfo);
  return response.data;
};

export const deleteDebtInformationApi = async (id) => {
  const response = await zreportapi.delete(`DataDebtInformations/${id}`);
  return response.data;
};
